import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavegate } from 'App/hooks';
import NuvemAppPage from 'domains/PartnersApps/pages/NuvemAppPage';

export function EmailMarketingPage() {
  const { pathname, goTo } = useNavegate();
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash.includes('/email-marketing')) {
      goTo(`${pathname}#/email-marketing`);
    }
  }, [pathname, goTo, hash]);

  return <NuvemAppPage code="marketing-automation" />;
}
